module.exports = __webpack_public_path__ + "img/plasma_t.unlinked.3f1c3ae.png";